export default __webpack_public_path__ + "static/media/lundberg.8ffa7c96.jpeg";